export const TWO_FACTOR_AUTH_KEY="2FA_KEY"